module.exports = __webpack_public_path__ + "img/6.167e1721.jpg";